export default __webpack_public_path__ + "static/media/SearchJournal2.6ccefc55.svg";